import { render } from "./MyPageNon2.vue?vue&type=template&id=e16cc2b8&scoped=true&ts=true"
import script from "./MyPageNon2.vue?vue&type=script&lang=ts"
export * from "./MyPageNon2.vue?vue&type=script&lang=ts"

import "./MyPageNon2.vue?vue&type=style&index=0&id=e16cc2b8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16cc2b8"]])

export default __exports__